import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";

import { Button } from "../buttons";

import { CommonDialog, CommonDialogTitle, CommonDialogContent, CommonDialogActions } from "./common-dialog.jsx";

import "./style.less";

const ForceQuitDialog = ({ onClose, ...props }) => {
    const intl = useIntl();
    const title = intl.formatMessage({ id: "common.force-quit-dialog.title" });
    const text = intl.formatMessage({ id: "common.force-quit-dialog.text" });

    return(
        <CommonDialog {...props}>
            <CommonDialogTitle
                title={title}
                onClose={onClose}
            />

            <CommonDialogContent>
                <Typography component="p" className="delete-dialog-text">
                    {text}
                </Typography>
            </CommonDialogContent>

            <CommonDialogActions>
                <Button
                    variant="contained"
                    onClick={onClose}
                    sx={{
                        color: 'var(--bg-2)',
                        backgroundColor: 'var(--font-2)',
                        '&:hover': {
                            backgroundColor: 'var(--font-2)',
                        }
                    }}
                >
                    <FormattedMessage id="common.submit-dialog.btn-close" />
                </Button>
            </CommonDialogActions>
        </CommonDialog>
    )
};

ForceQuitDialog.propTypes = {
    onClose: PropTypes.func,
}

export default ForceQuitDialog;
